import {
  cloneElement,
  isValidElement,
  ReactElement,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDrag } from "../hooks/common/useDrag";
import { twMerge } from "tailwind-merge";
import { ReactNode } from "react";
interface SlideProps {
  children?: ReactNode;
  leftSlot?: ReactElement<{ success: boolean }>;
  rightSlot?: ReactElement<{ success: boolean }>;
  leftAdjust?: number;
  rightAdjust?: number;
  onSubmit?: (value: boolean) => unknown;
}
const getX = (x: number) => {
  const ratio = 1 + Math.log(x + 1) / 2; // 예시: 로그 함수를 사용하여 비율 증가
  return Math.max(x / ratio, 12);
};
export const Slide = ({
  children,
  leftSlot,
  rightSlot,
  leftAdjust = 30,
  rightAdjust = 30,
  onSubmit,
}: SlideProps) => {
  const [value, setValue] = useState<boolean | null>(null);
  const ref = useRef<HTMLButtonElement>(null);
  const {
    pos: { x },
    state,
  } = useDrag(ref, { limit: { y: 20 } });
  const dragging = useMemo(() => "move" === state, [state]);
  const notDragEnd = useMemo(
    () => ["move", "start"].includes(state ?? ""),
    [state]
  );

  const whichOne = useMemo(() => {
    // console.log(x, leftAdjust, rightAdjust);
    // console.log(value);
    if (x < -rightAdjust && rightSlot !== undefined) return true;
    else if (x > leftAdjust && leftSlot !== undefined) return false;
    // console.log("null");
    return null;
  }, [x, leftAdjust, rightAdjust, leftSlot, rightSlot, value]);

  const adjustLeft = useMemo(() => {
    if (!notDragEnd) return undefined;

    if (x < 0 || !leftSlot) return 0;
    return getX(x);
  }, [x, leftSlot, notDragEnd]);

  const adjustRight = useMemo(() => {
    if (!notDragEnd) return undefined;

    if (x > 0 || !rightSlot) return 0;

    return getX(-x);
  }, [x, rightSlot, notDragEnd]);

  useEffect(() => {
    if (!notDragEnd) return;
    setValue(whichOne);
  }, [whichOne, notDragEnd]);

  useEffect(() => {
    if (value === null) return;

    onSubmit?.(value);
  }, [value, onSubmit]);

  return (
    <div className="flex items-center">
      <div
        style={{
          maxWidth: adjustLeft,
        }}
        className={twMerge(
          "overflow-hidden",
          dragging ? "" : "transition-all",
          value !== false && "max-w-0",
          value === false && "max-w-96"
        )}
      >
        {isValidElement<{ success: boolean }>(leftSlot) &&
          value !== null &&
          cloneElement(leftSlot, { success: value === false })}
      </div>
      <button ref={ref} className="flex-auto mx-2 rounded-md border">
        {children}
      </button>
      <div
        style={{
          maxWidth: adjustRight,
        }}
        className={twMerge(
          "overflow-hidden",
          dragging ? "" : "transition-all",
          value !== true && "max-w-0",
          value === true && "max-w-96"
        )}
      >
        {isValidElement<{ success: boolean }>(rightSlot) &&
          value !== null &&
          cloneElement(rightSlot, { success: value === true })}
      </div>
    </div>
  );
};
